import { render } from "./CoachDetail.vue?vue&type=template&id=04509d59"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__